import React from 'react'

import {
  ListElementType,
  ListItemElementType,
  StructuredText,
  StructuredTextLeaf as StructuredTextLeafType,
  TextElementType
} from '@app/lib/inputs/RichEditor/types'

import './StructuredTextDisplay.scss'

type StructuredTextNodeProps = {
  node: StructuredText[number]
}

const StructuredTextNode = ({ node }: StructuredTextNodeProps) => {
  if ('text' in node) {
    return <StructuredTextLeaf node={node as StructuredTextLeafType} />
  }

  const children = (node.children || []).map((child, index) => (
    <StructuredTextNode node={child} key={index} />
  ))

  switch (node.type) {
    case TextElementType.Paragraph:
      return <p>{children}</p>

    case TextElementType.HeadingOne:
      return <div className='structured-text__h1'>{children}</div>

    case TextElementType.HeadingTwo:
      return <div className='structured-text__h2'>{children}</div>
    case ListElementType.BulletedList:
      return <ul>{children}</ul>

    case ListElementType.NumberedList:
      return <ol>{children}</ol>

    case ListItemElementType.ListItem:
      return <li>{children}</li>
  }

  throw new Error(
    `serialisation of node ${JSON.stringify(node, Object.getOwnPropertyNames(node))} not supported`
  )
}

type StructuredTextLeafProps = {
  node: StructuredTextLeafType
}

const StructuredTextLeaf = ({ node }: StructuredTextLeafProps) => {
  let element = <span>{node.text}</span>

  if (node.Bold) {
    element = <b>{element}</b>
  }

  if (node.Italic) {
    element = <i>{element}</i>
  }

  if (node.Underline) {
    element = <u>{element}</u>
  }

  return element
}

export type StructuredTextProps = {
  nodes: StructuredText
}

export const StructuredTextDisplay = ({ nodes }: StructuredTextProps) => {
  return (
    <div className='structured-text'>
      {nodes.map((node, index) => (
        <StructuredTextNode node={node} key={index} />
      ))}
    </div>
  )
}
